import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-nvidia-dark to-nvidia-dark-800 text-gray-300">
      <div className="container mx-auto px-6 py-12">
        <Link to="/" className="text-nvidia-green hover:text-nvidia-green-light mb-8 inline-block">
          ← Back to Home
        </Link>
        
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-8">Terms of Service</h1>
          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">1. Agreement to Terms</h2>
              <p className="mb-4">
                By accessing or using Botrex AI's services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">2. Use License</h2>
              <p className="mb-4">
                Subject to your compliance with these Terms, Botrex AI grants you a limited, non-exclusive, non-transferable, non-sublicensable license to access and use our AI services for your business purposes.
              </p>
              <h3 className="text-xl font-semibold text-white mb-3">2.1 Restrictions</h3>
              <p className="mb-4">You may not:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Modify or copy our proprietary AI algorithms</li>
                <li>Use our services for any illegal purpose</li>
                <li>Attempt to decompile or reverse engineer our software</li>
                <li>Remove any copyright or proprietary notations</li>
                <li>Transfer the services to another person or entity</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">3. Service Availability and Support</h2>
              <p className="mb-4">
                We strive to provide uninterrupted service but may need to perform maintenance or updates. We will provide reasonable notice of any scheduled maintenance. Technical support is available according to your service plan.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">4. Data Usage and Privacy</h2>
              <p className="mb-4">
                Your use of our services is also governed by our Privacy Policy. You agree that Botrex AI may use your data to:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Provide and improve our AI services</li>
                <li>Train and enhance our AI models</li>
                <li>Generate aggregated insights</li>
                <li>Comply with legal requirements</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">5. Intellectual Property</h2>
              <p className="mb-4">
                All rights, title, and interest in and to the services (excluding content provided by users) are and will remain the exclusive property of Botrex AI. Our services are protected by copyright, trademark, and other laws.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">6. User Obligations</h2>
              <p className="mb-4">You agree to:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Provide accurate information</li>
                <li>Maintain the security of your account</li>
                <li>Comply with all applicable laws</li>
                <li>Use the services responsibly</li>
                <li>Report any security vulnerabilities</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">7. Payment Terms</h2>
              <p className="mb-4">
                Services are billed according to your selected plan. You agree to pay all fees and applicable taxes. Fees are non-refundable except as required by law or as explicitly stated in our refund policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">8. Limitation of Liability</h2>
              <p className="mb-4">
                Botrex AI shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">9. Termination</h2>
              <p className="mb-4">
                We may terminate or suspend your access to our services immediately, without prior notice, for any breach of these Terms. Upon termination, your right to use the services will immediately cease.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">10. Changes to Terms</h2>
              <p className="mb-4">
                We reserve the right to modify these terms at any time. We will notify you of any material changes by posting the new Terms on this page and updating the "Last Updated" date.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-nvidia-green mb-4">11. Contact Information</h2>
              <p className="mb-4">
                Questions about the Terms of Service should be sent to:
                <br />
                Email: legal@botrex.ai
                <br />
                Address: [Company Address]
              </p>
            </section>

            <p className="text-sm text-gray-400 mt-8">Last Updated: [Current Date]</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
